import { useStateDebounced } from "./useStateDebounced.js";
import { useUrlState } from "./useUrlState.js";
import { useEffect } from "react";
//#region src/hooks/useUrlStateDebounced.ts
function useUrlStateDebounced(urlParam, defaultValue, opts) {
	const [value, setValue] = useUrlState(urlParam, defaultValue, opts);
	const [val, debouncedVal, setVal] = useStateDebounced(value, opts?.delay ?? 500);
	useEffect(() => {
		setValue(debouncedVal);
	}, [debouncedVal]);
	return [
		val,
		debouncedVal,
		setVal
	];
}
//#endregion
export { useUrlStateDebounced };

//# sourceMappingURL=useUrlStateDebounced.js.map